<template>
  <div class="order-modal order-modal_mh80">
    <component :is="component" :order="order" @fetch="onFetch" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

import mainView from "@/components/modals/orders/views/mainView";
import errorView from "@/components/modals/orders/views/errorPaymentView";
import paymentView from "@/components/modals/orders/views/paymentView";
import rateView from "@/components/modals/orders/views/rateView";
import paymentWidget from "@/components/modals/orders/views/paymentWidget";

import orders from "@/mixins/orders";

export default {
  name: "order-modal",
  mixins: [orders],
  components: {
    mainView,
    errorView,
    rateView,
    paymentView,
    paymentWidget
  },
  computed: {
    ...mapGetters({
      order: "orders/order",
      component: "orders/isComponent"
    })
  },
  methods: {
    ...mapMutations({
      setState: "orders/setState",
      setList: "orders/setList"
    }),
    ...mapActions({
      fetch: "orders/fetch"
    }),
    async onFetch() {
      this.fetchOrdersMixin();
    }
  },
  mounted() {
    this.$log("orderStatus");
  }
};
</script>

<style lang="scss">
.order {
  &-modal {
    &__head {
      position: relative;
    }

    &__content {
      padding: 10px 20px;
    }

    &__status {
      padding: 5px;
      background-color: #d5f5f6;
      border-radius: 5px;
      position: absolute;
      right: 0;
      top: -5px;
    }
  }

  &-service {
    display: flex;
    align-items: center;

    &__text {
      margin: 10px;
    }
  }

  &-material {
    display: flex;
    align-items: center;

    &__text {
      margin: 10px;
    }
  }
}
</style>
